import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import './Team.css'
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, Button, IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import useTable from '../../useTable';
import SearchIcon from '@material-ui/icons/Search';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import Popup from '../../Popup';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../../CustomAlert';
import EditIcon from '@material-ui/icons/Edit';
import { Helmet } from 'react-helmet';
import { getTeamDocumentWithUserId } from '../../../Backend/firebase/team';
import TeamFilter from './TeamFilter';
import UpdateTeam from './UpdateTeam';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'MemberName', label: 'Member Name', disableSorting: false },
    { id: 'Role', label: 'Role', disableSorting: false },
    { id: 'Department', label: 'Department', disableSorting: true },
    { id: 'action', label: 'Action', disableSorting: false },
]

function AllTeam() {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [searchChange, setSearchChange] = useState(false);
    const [pageAfterSearch, setPageAfterSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn,
        searchChange, pageAfterSearch);
    const [openPopup, setOpenPopup] = useState(false);
    const [updatedMemberId, setUpdatedMemberId] = useState('');
    const [uniqueMemberId, setUniqueMemberId] = useState('');
    const history = useHistory();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');

    const handleSearch = (e) => {
        let target = e.target;
        if (target.value === '') {
            setSearchChange(false);
            setPageAfterSearch(false);
        }
        else {
            setSearchChange(true);
            setPageAfterSearch(true);
        }
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items
                } else {
                    return items.filter(x => x.MemberName.toLowerCase().includes(target.value.toLowerCase()));
                }
            }
        });
    };

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getTeam = await getTeamDocumentWithUserId(userData.uid);
                setRecords(getTeam);
                setIsLoading(false);
            } catch(error) {
                console.log("Error Occur in Get Team", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const updateTeam = (_id, memberId) => {
        setUniqueMemberId(_id);
        setUpdatedMemberId(memberId);
        setOpenPopup(true);
    };

    const handleFilters = async (filter) => {
        console.log('Filter Changed => ', filter);
    };

    const refreshData = async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getTeam = await getTeamDocumentWithUserId(userData.uid);
                console.log("getTeam",getTeam)
                setRecords(getTeam);
                setIsLoading(false);
                setNotificationMessage('Team data has updated successfully.');
                setOpenNotify(true);
                setAlertType('success');
            } catch(error) {
                console.log("Error Occur in Get Team", error)
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allTeam">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Team you have posted till now." />
                            <title>Team | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-8">
                                <TeamFilter handleFilters={handleFilters} refreshData={refreshData} />
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center w-100 align-items-center allProductsTable__searchBox">
                                    <SearchIcon className="mr-2" />
                                    <input type="text" placeholder="Search Team..." className="border-0"
                                        onChange={handleSearch} />
                                </div>
                            </div>
                            {records.length > 0 ? <div className="row col-md-12">
                                <TblContainer>
                                    {/* <TblHead />
                                    <TableBody> */}
                                        {
                                            recordsAfterPagingAndSorting().map(item => (
                                                <>
                                                    <div className="col-lg-4 col-md-4 col-sm-12 topSkills topSkills__productDisplay" key={item.id}>
                                                        <div className="card-events card-products all-products">
                                                            <div className="card-events-body d-flex flex-column white__background__color position__class">
                                                                <div className="product__edit">
                                                                    <Tooltip title="Edit Team" placement="top">
                                                                        <IconButton color="primary"
                                                                            onClick={() => updateTeam(item._id, item.uniqueId)}>
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </div>
                                                                <div className="card-team-details">
                                                                    <h5 className="card-events-title black__color product__mainTitle">{item.MemberName}</h5>
                                                                    <p className="card-events-title black__color">{item.Role}</p>
                                                                    {item?.MemberEmail && <p className="card-events-title black__color"><b>{item.MemberEmail}</b></p>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <TableRow key={item.id}>
                                                        <TableCell>{item.MemberName}</TableCell>
                                                        <TableCell>{item.Role}</TableCell>
                                                        <TableCell>{item.Department ? item.Department : "NA"}</TableCell>
                                                        <TableCell>
                                                            <Tooltip title="Edit Team" placement="top">
                                                                <IconButton color="secondary"
                                                                    onClick={() => updateTeam(item._id, item.uniqueId)}>
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow> */}
                                                </>
                                            ))
                                        }
                                    {/* </TableBody> */}
                                </TblContainer>
                                <TblPagination />
                            </div> : <div className="row col-md-12 mt-3 text-center">
                                <img src={NotFound} className="notFound" />
                                <h4>No Team Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                </div>)
            }
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />

            <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="Update Team" popupSize="md">
                <UpdateTeam _id={uniqueMemberId} memberId={updatedMemberId} setOpenPopup={setOpenPopup} refreshData={refreshData} />
            </Popup>
        </>
    )
}

export default AllTeam
